import { cartLineNotesStyles } from "@insite/content-library/Widgets/Cart/CartLineNotes";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

cartLineNotesStyles.label = {
    css: css`
        button {
            color: ${getColor("text.link")};
            font-size: ${TYPOGRAPHY.size.tiny};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-family: ${TYPOGRAPHY.fontFamily.title};
            line-height: 16px;
            background: none;
            border: none;
            padding: 0;
            cursor: pointer;
        }
    `,
};
